module.exports = __webpack_public_path__ + "img/re.bb0beca2.png";